import { Container, Row, Col } from 'react-bootstrap'
import SocialIcons from '../ui/SocialIcons'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <div 
      className="footer" 
      style={{ backgroundImage: 'url(/images/relentless images/solid-black-img.jpg)' }}
    >
      <div className="content-wrap">
        <Container>
          <Row>
            <Col sm={12} md={12} lg={12}>
              <div className="text-center">
                <img 
                  src="/images/relentless images/relentless-logo.jpg" 
                  alt="Relentless Performance Training" 
                  className="mb-5"
                />
                <br />
                <SocialIcons centered />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="fcopy">
        <Container>
          <Row>
            <Col sm={12} md={12}>
              <p className="ftex">
                Copyright {currentYear} &copy;{' '}
                <span className="color-primary">Relentless Performance Training</span>. 
                Designed by <span className="color-primary">Rometheme | Modified and Developed by{' '}
                  <a href="https://adriancallies.com/" target="_blank" rel="noopener noreferrer">
                    Adrian Callies
                  </a>
                </span>
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default Footer


